import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';

if (process.env.REACT_APP_ID !== 'franchising-extra') {
  (function (k, s) {
    s = document.createElement('script');
    s.module = true;
    s.async = true;
    s.src = 'https://cdn.feedbucket.app/assets/feedbucket.js';
    s.dataset.feedbucket = k;
    document.head.appendChild(s);
  })('HLTQEcAbA6jAFYFPZl61');
}

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
